import { showdown as evaluateShowdown } from '../core';
import { dealForSpec } from './deal';
import { orderSeatsFromButton } from './positions';
const awardTo = (players, seat, amount) => players.map((p) => (p.seat === seat ? { ...p, stack: p.stack + amount } : p));
/** Only one player never folded (everyone else folded before showdown) - award every pot to them,
 *  no hand evaluation needed. */
export const awardUncontested = (state) => {
    const winner = state.players.find((p) => !p.folded);
    if (!winner)
        throw new Error('awardUncontested called with no unfolded player');
    let players = state.players;
    for (const pot of state.pots)
        players = awardTo(players, winner.seat, pot.amount);
    return { ...state, players, pots: [], phase: 'complete' };
};
export const resolveShowdown = (state) => {
    const n = state.players.length;
    const { holeCards } = dealForSpec(state.spec, n);
    const contestants = state.players.filter((p) => !p.folded);
    let players = state.players;
    for (const pot of state.pots) {
        const eligible = contestants.filter((p) => pot.eligibleSeats.includes(p.seat));
        if (eligible.length === 0)
            continue;
        if (eligible.length === 1) {
            players = awardTo(players, eligible[0].seat, pot.amount);
            continue;
        }
        const hands = eligible.map((p) => holeCards[p.seat]);
        const winnerIdxs = evaluateShowdown(hands, state.board);
        const winnerSeats = winnerIdxs.map((i) => eligible[i].seat);
        const orderedWinners = orderSeatsFromButton(winnerSeats, state.buttonSeat, n);
        // Odd chips go to the first seats left of the button. `remainder` is DRAINED rather than used as
        // a count, because it is not always a whole number: bet sizings are pot fractions (SIZING_FRACTION
        // carries 1/3 and 2/3), so pots are routinely fractional - e.g. `9.5`, `16.25`. The old
        // `share + (i < remainder ? 1 : 0)` treated it as a count of whole chips and MINTED the shortfall:
        // a 100.5 pot chopped two ways paid out 50 + 51 = 101. Draining it pays out exactly `pot.amount`.
        //
        // For an INTEGER pot this is byte-identical to the old behavior: remainder is then a whole count k,
        // so the first k winners each drain exactly 1 and the rest drain 0.
        const share = Math.floor(pot.amount / orderedWinners.length);
        let remainder = pot.amount - share * orderedWinners.length;
        orderedWinners.forEach((seat) => {
            const oddChip = Math.min(1, remainder);
            players = awardTo(players, seat, share + oddChip);
            remainder -= oddChip;
        });
    }
    // Reveal hole cards for everyone who reached showdown (for UI/history; hero's were already set).
    players = players.map((p) => {
        if (p.folded)
            return p;
        return { ...p, holeCards: holeCards[p.seat] };
    });
    return { ...state, players, pots: [], phase: 'complete' };
};
//# sourceMappingURL=showdown.js.map